import {
  byUserInteraction,
  libInit,
  parameters,
  sendGoogleEvent,
} from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - ';

export default function CommonClpPopups() {
  const openYoutubePopup = (customPopupClass, videoId, autoplay) => {
    libInit('popup', () => {
      $.magnificPopup.open({
        mainClass: customPopupClass,
        items: {
          src: `https://www.youtube.com/watch?v=${videoId}`,
        },
        type: 'iframe',
        iframe: {
          markup:
            '<div class="mfp-iframe-scaler mfp-iframe-scaler-no-shadow"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe></div>',
          patterns: {
            youtube: {
              index: 'youtube.com/',
              id: 'v=',
              src: `//www.youtube-nocookie.com/embed/%id%?&showinfo=0&rel=0&autoplay=${autoplay}`,
            },
          },
          srcAction: 'iframe_src',
        },
      });
    });
  };

  const createIFrame = (customIframeClass, videoId, autoplay) => $(`<iframe class="${customIframeClass}">`, {
    src: `//www.youtube-nocookie.com/embed/${videoId}?rel=0&autoplay=${autoplay}&controls=1&showinfo=0`,
    id: `video${videoId}`,
    frameborder: 0,
    allowfullscreen: true,
    scrolling: 'no',
  });

  const onClickVideo = (event, params) => {
    const $target = $(event.currentTarget);
    const videoId = $target.data('video');
    const eventCategory = $target.data('event-category');
    const isOpenedInPopup = $target.data('is-opened-in-popup') || 0;
    const isDesktop = !(parameters.is_mobile || parameters.is_tablet);

    let autoplay = $target.data('autoplay') || 0;
    if (params && params.isUserInteraction) {
      if (isOpenedInPopup) return true;

      autoplay = 0;
    }

    if (isOpenedInPopup || isDesktop) {
      openYoutubePopup('ao-clp-popup', videoId, autoplay);
    } else {
      const $iframe = createIFrame(
        'ao-clp-hero__video-frame',
        videoId,
        autoplay,
      );

      $target.closest('.js-ao-clp-hero').prepend($iframe);
    }

    if (eventCategory) {
      sendGoogleEvent(EVENT_CATEGORY + eventCategory, 'Play', videoId);
    }

    return true;
  };

  const onclickImage = (event) => {
    event.preventDefault();

    libInit('popup', () => {
      $.magnificPopup.open({
        type: 'image',
        mainClass: 'ao-clp-popup',
        items: {
          src: $(event.currentTarget).attr('href'),
        },
      });
    });
  };

  const initiateImage = () => {
    const $images = $('.js-ao-clp-image-popup');

    if ($images.length) {
      $images.each((index, element) => {
        $(element).click(onclickImage);
      });
    }
  };

  const initiateVideo = () => {
    const $videos = $('.js-ao-clp-hero__play');

    if ($videos.length) {
      $videos.each((index, element) => {
        $(element).click(onClickVideo);
      });
    }
  };

  const initiate = () => {
    initiateVideo();

    byUserInteraction('initiate-popups', () => libInit('popup', initiateImage));
  };

  return { initiate, openYoutubePopup, createIFrame };
}
